// src/firebase-config.ts

import { initializeApp } from "firebase/app";
import { getMessaging } from "firebase/messaging";
import { getAnalytics } from "firebase/analytics";

// Firebase 콘솔에서 가져온 웹 앱의 Firebase 설정
const firebaseConfig = {
  apiKey: "AIzaSyDmYd0pqWVReN44umQJPYEsLIUUm1zKKW8", // 실제 값으로 교체
  authDomain: "playball-fantasy.firebaseapp.com",
  projectId: "playball-fantasy",
  storageBucket: "playball-fantasy.firebasestorage.app",
  messagingSenderId: "74323677815", // 실제 값으로 교체
  appId:"1:74323677815:web:ca2497608a360feb2eac72" // 실제 값으로 교체
};

// Firebase 앱 초기화
const app = initializeApp(firebaseConfig);

const isFcmSupported =
  typeof window !== 'undefined' &&
  'serviceWorker' in navigator &&
  'PushManager' in window &&
  'Notification' in window;

// 지원되는 환경에서만 getMessaging을 호출하여 messaging 인스턴스를 생성합니다.
// 지원되지 않는 환경이라면 null을 할당합니다.
export const messaging = isFcmSupported ? getMessaging(app) : null;
export const analytics = getAnalytics(app);

// app 인스턴스 자체를 export 할 수도 있습니다.
export default app;
